import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Trash2, Pencil, Inbox } from "lucide-react";

const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
};

export default function EntriesTable({ entries, onDelete, onEdit }) {
  if (!entries.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="entries-empty">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#FCE7F3] text-[#E6017D]">
          <Inbox size={26} strokeWidth={1.5} />
        </span>
        <p className="mt-4 font-heading text-lg text-[#212529]">Noch keine Einträge</p>
        <p className="text-sm text-[#5F6368] mt-1">Dokumentiere oben deinen ersten Bautag.</p>
      </div>
    );
  }

  return (
    <div data-testid="entries-table">
      {/* Mobile Card List: visible below sm breakpoint */}
      <div className="block sm:hidden divide-y divide-[#E2E2E2]">
        {entries.map((e) => (
          <div
            key={e.id}
            className="p-4 flex flex-col gap-2 hover:bg-[#FCE7F3]/10 transition-colors"
            data-testid={`entry-row-${e.id}`}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold text-[#5F6368] bg-[#F4F4F4] px-2 py-1 rounded">
                {fmtDate(e.date)}
              </span>
              <span className="text-sm font-semibold text-[#E6017D] bg-[#FCE7F3] px-2.5 py-0.5 rounded-full">
                {e.hours} {e.hours === 1 ? "Std." : "Std."}
              </span>
            </div>

            <div className="mt-1">
              <h4 className="font-semibold text-base text-[#212529]">{e.helper_name}</h4>
              <p className="text-sm text-[#5F6368] mt-0.5">{e.work_type}</p>
            </div>

            <div className="flex items-center justify-end gap-2 mt-2 pt-2 border-t border-[#E2E2E2]/50">
              <Button
                variant="ghost"
                size="sm"
                data-testid={`edit-entry-${e.id}`}
                onClick={() => onEdit(e)}
                className="h-9 px-3 text-[#5F6368] hover:text-[#E6017D] hover:bg-[#FCE7F3] flex items-center gap-1.5"
              >
                <Pencil size={15} />
                <span className="text-xs font-medium">Bearbeiten</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                data-testid={`delete-entry-${e.id}`}
                onClick={() => onDelete(e.id)}
                className="h-9 px-3 text-[#5F6368] hover:text-[#D11A2A] hover:bg-[#D11A2A]/10 flex items-center gap-1.5"
              >
                <Trash2 size={15} />
                <span className="text-xs font-medium">Löschen</span>
              </Button>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop Table View: visible at and above sm breakpoint */}
      <div className="hidden sm:block overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-[#E2E2E2] hover:bg-transparent">
              <TableHead className="text-[#5F6368] uppercase text-xs tracking-wide">Datum</TableHead>
              <TableHead className="text-[#5F6368] uppercase text-xs tracking-wide">Vorname und Name</TableHead>
              <TableHead className="text-[#5F6368] uppercase text-xs tracking-wide text-center">Stunden</TableHead>
              <TableHead className="text-[#5F6368] uppercase text-xs tracking-wide">Art der Bauarbeiten</TableHead>
              <TableHead className="w-20"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {entries.map((e) => (
              <TableRow key={e.id} className="border-[#E2E2E2]" data-testid={`entry-row-${e.id}`}>
                <TableCell className="text-[#212529] whitespace-nowrap">{fmtDate(e.date)}</TableCell>
                <TableCell className="text-[#212529] font-medium">{e.helper_name}</TableCell>
                <TableCell className="text-center text-[#212529]">{e.hours}</TableCell>
                <TableCell className="text-[#212529]">{e.work_type}</TableCell>
                <TableCell>
                  <div className="flex items-center justify-end gap-1">
                    <Button variant="ghost" size="icon" data-testid={`edit-entry-${e.id}`}
                      onClick={() => onEdit(e)}
                      className="h-8 w-8 text-[#5F6368] hover:text-[#E6017D] hover:bg-[#FCE7F3]">
                      <Pencil size={16} />
                    </Button>
                    <Button variant="ghost" size="icon" data-testid={`delete-entry-${e.id}`}
                      onClick={() => onDelete(e.id)}
                      className="h-8 w-8 text-[#5F6368] hover:text-[#D11A2A] hover:bg-[#D11A2A]/10">
                      <Trash2 size={16} />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
